import React from 'react';
import '../less/main.less';

export default function template() {
    const {isMobile, data, children, img} = this.props,
      list = <ul className="hint-list">
        {data.list ?
          (data.list.map(el => {
            return (
              <li key={el} className="hint-list-item" dangerouslySetInnerHTML={{__html: this.l10n(el)}}/>
            )
          })) : ''}
      </ul>

    return (
      <div className="hint">
        <div className="hint-title"><span className="danger-icon"/>{this.l10n(data.title)}</div>
        <div className='hint-text'>{this.l10n(data.text)}</div>
        {list}
        {children ? children : ''}
        {img ? <img src={img} alt='hint_img' className='hint-img' /> : ''}
      </div>
    );

}
